var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIPending = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -80.358)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 80.358)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.092 80.266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,1.092A6.908,6.908,0,1,0,14.908,8,6.908,6.908,0,0,0,8,1.092ZM8,13.9A5.9,5.9,0,1,1,13.9,8,5.9,5.9,0,0,1,8,13.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.486,2.8a.5.5,0,0,0-.623.337L7.555,7.717,4.971,9.978a.506.506,0,1,0,.667.761l2.7-2.358a.5.5,0,0,0,.151-.243L9.833,3.421A.5.5,0,0,0,9.491,2.8Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIPending, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_pending.79ea653f.svg";
export { ForwardRef as ReactComponent };